export default __webpack_public_path__ + "static/media/imeuble.efc08456.png";